/**
 * Resolves `available-wallet-types` / similar payloads to a string array.
 * Handles raw arrays, nested `data`, `wallet_types`, and object rows.
 */
export function extractWalletTypesArrayFromResponse(data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (typeof data !== "object") return [];
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data.types)) return data.types;
  if (Array.isArray(data.wallet_types)) return data.wallet_types;
  if (Array.isArray(data.walletTypes)) return data.walletTypes;
  return [];
}

/** Lowercase slug for URL / `wallet_type` query (matches `/user_profile/wallet/:walletType`). */
export function normalizeWalletTypesList(raw) {
  const arr = Array.isArray(raw) ? raw : [];
  const out = [];
  for (const item of arr) {
    if (item == null) continue;
    if (typeof item === "string") {
      const s = item.trim().toLowerCase();
      if (s) out.push(s);
      continue;
    }
    if (typeof item === "object") {
      const s = String(
        item.wallet_type ?? item.walletType ?? item.type ?? item.key ?? item.slug ?? item.id ?? "",
      )
        .trim()
        .toLowerCase();
      if (s) out.push(s);
    }
  }
  return [...new Set(out)];
}

/** Slugs linked from `WalletSidebar` / `AuthHeader` — valid `/user_profile/wallet/:walletType` targets (generic `WalletPage`). */
export const WALLET_ROUTE_SLUGS = new Set(["main", "spot", "p2p", "swap", "earning", "margin", "cross_margin", "futures"]);
